import React, { Fragment } from 'react';
import cx from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import gs from 'pages/pages.module.css';
import s from 'pages/homeStyles.module.css';
import WL from 'constants/whiteLabel';
import hexColoredBig from "utils/images/hex-colored-big.svg";
import hexWhiteSmall from "utils/images/hex-white-small.svg";
import playIcon from "utils/images/play.svg";
import Link from 'components/Link';
import styles from './intro.module.css';

const Intro = ({
  animateHowItWork,
  openModal
}) => {
  const intl = useIntl();

  return (
     <section className={cx(gs.content, gs.topUnderSub)}>
      <div className={cx(gs.wrapper, s.wrapper)}>
      <div className={s.intro}>
        <div className={gs.msg}>
        <h1 className={gs.accent}>
          <FormattedMessage id="deploy_monitor_manage" defaultMessage="Deploy. Monitor. Manage." />
        </h1>
        <p>
          <FormattedMessage id="ultimate_mining_platform" defaultMessage="The ultimate mining platform that allows users to setup, mine and control processes more efficiently and hustle-free across thousands of rigs all in one place. Everything you and your team need to keep your farm at its peak efficiency" />
        </p>
        </div>
        <div className={s.imgContainer}>
          {
            WL.showHexImg ? (
              <Fragment>
                <img
                  alt="hex"
                  className={cx(s.hexColoredBig, { [s.hexColoredBigAnimation] : animateHowItWork })}
                  src={hexColoredBig}
                />
                <img
                  alt="hex"
                  className={cx(s.hexWhiteSmall1, { [s.hexWhiteSmall1Animation] : animateHowItWork })}
                  src={hexWhiteSmall}
                />
                <img
                  alt="hex"
                  className={cx(s.hexWhiteSmall2, { [s.hexWhiteSmall2Animation] : animateHowItWork })}
                  src={hexWhiteSmall}
                />
              </Fragment>
            ) : null
          }
          {WL.getHowItWorks() && (
            <Fragment>
              <div className={cx(styles.howItWorks, s.howItWorks)} onClick={openModal} role="presentation">
                <img alt="play icon" className={s.playIcon} src={playIcon}/>
                <FormattedMessage id="how_it_works" defaultMessage="How it works" />
              </div>
              <Link
                className={cx(styles.howItWorksLink, s.howItWorks)}
                href={WL.getHowItWorks(intl.lang, 'en')}
                external
                noRef
              >
                <img alt="play icon" className={s.playIcon} src={playIcon}/>
                <FormattedMessage id="how_it_works" defaultMessage="How it works" />
              </Link>
            </Fragment>
          )}
        </div>
      </div>
      <div className={s.moreLinks}>
        <Link external noRef href={WL.getRegisterLink()} className="btn-primary-big">
          <FormattedMessage id="start_for_free" defaultMessage="Start For Free" />
        </Link>
      </div>
      </div>
    </section>
  );
}

export default Intro;
